import { render } from "./beautyEdu.vue?vue&type=template&id=a5891b2e&scoped=true"
import script from "./beautyEdu.vue?vue&type=script&lang=js"
export * from "./beautyEdu.vue?vue&type=script&lang=js"

import "./beautyEdu.vue?vue&type=style&index=0&id=a5891b2e&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5891b2e"]])

export default __exports__